import { render, staticRenderFns } from "./CommercialClaimEdit.vue?vue&type=template&id=6095b6d8&scoped=true&"
import script from "./CommercialClaimEdit.vue?vue&type=script&lang=js&"
export * from "./CommercialClaimEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6095b6d8",
  null
  
)

export default component.exports